export function AddStructuredData({
  category,
  reviewAverage,
  reviewCount,
} = {}) {
  // Remove existing structured data if any
  const existingStructuredData = document.querySelector(
    'script[type="application/ld+json"]'
  );
  if (existingStructuredData) {
    existingStructuredData.remove();
  }

  // I suspect this is done so that these variables are persisted across renders, and that we only
  // have these values for the first render? There are more React-y ways of doing this, but that's
  // fine I guess.
  if (reviewAverage && reviewCount) {
    window.averageReviewsValue = reviewAverage;
    window.reviewsCount = reviewCount;
    window.category = category;
  }

  let title = document.title
    .split(' | ')[0] // Only keep what's before the `|` character
    .replace(/^(Buy|Browse) /, ''); // Remove "Buy" or "Browse" prefix

  const metaDescriptionEl = document.querySelector('meta[name="description"]');

  const structuredJSON = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'League of Legends Accounts',
    image: `${window.location.origin}/images/logo.png`,
    description: metaDescriptionEl ? metaDescriptionEl.content : null,
    brand: 'Unranked Smurfs',
    offers: {
      '@type': 'AggregateOffer',
      url: `${window.location.origin}/league-of-legends/lol-account/category/${window.category}`,
      priceCurrency: 'USD',
      lowPrice: '24.99',
      highPrice: '179.99',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
    },
    aggregateRating: {
      '@context': 'https://schema.org/',
      '@type': 'AggregateRating',
      ratingValue: window.averageReviewsValue,
      reviewCount: window.reviewsCount,
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: '1',
          item: {
            '@id': `https://www.unrankedsmurfs.com${window.location.pathname}`,
            name: `${title}`,
          },
        },
      ],
    },
    review: [
      {
        '@type': 'Review',
        name: 'Kyle B',
        reviewBody: 'Quick, easy, and works like a charm',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
        },
        datePublished: '2019-07-09',
        author: { '@type': 'Person', name: 'Kyle B' },
        publisher: { '@type': 'Organization', name: 'Reviews.io' },
      },
      {
        '@type': 'Review',
        name: 'Thomas W',
        reviewBody: 'Really easy, safe as well and very trusted. Good job.',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
        },
        datePublished: '2019-07-09',
        author: { '@type': 'Person', name: 'Thomas W' },
        publisher: { '@type': 'Organization', name: 'Reviews.io' },
      },
    ],
  };

  const dataStructureJson = document.createElement('script');
  dataStructureJson.type = 'application/ld+json';
  dataStructureJson.text = JSON.stringify(structuredJSON);

  document.head.appendChild(dataStructureJson);

  return null;
}
